import * as React from 'react';

export const context = React.createContext({});

// 全局拦截器用于检测服务器连接状态
export const setupFetchInterceptor = (setServerMaintenance) => {
    const originalFetch = window.fetch;
    
    window.fetch = async (...args) => {
        try {
            const response = await originalFetch(...args);
            
            // 检测服务器错误或连接失败
            if (!response.ok && (response.status >= 500 || response.status === 0)) {
                setServerMaintenance(true);
            }
            
            return response;
        } catch (error) {
            // 网络错误或无法连接到服务器
            if (error.name === 'TypeError' || error.message.includes('Failed to fetch')) {
                setServerMaintenance(true);
            }
            throw error;
        }
    };
};